import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { FolderPlus, Plus } from 'lucide-react'
import { useState } from 'react'
import TitleHeader from '@/components/TitleHeader'
import { Button } from '@/components/ui/button'
import { StaticCard } from '@/components/StatCards'
import { RecentOrders } from '@/components/RecentOrders'
import OrderChart from '@/components/OrderChart'
import PaymentChart from '@/components/PaymentChart'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export const Route = createFileRoute('/_authenticated/')({
  component: DashboardPage,
})

function DashboardPage() {
  const navigate = useNavigate()
  const [currency, setCurrency] = useState<'vnd' | 'usd'>('vnd')

  const groupActions = () => {
    return (
      <>
        <Select
          value={currency}
          onValueChange={(value: 'vnd' | 'usd') => setCurrency(value)}
        >
          <SelectTrigger className="w-[140px] mr-3">
            <SelectValue placeholder="Theo tiền tệ" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="vnd">VND</SelectItem>
            <SelectItem value="usd">USD</SelectItem>
          </SelectContent>
        </Select>
        <Button variant="outline" className="mr-3" onClick={() => {}}>
          <FolderPlus />
          Xuất dữ liệu
        </Button>
        <Button
          className="bg-blue-600 hover:bg-blue-700"
          onClick={() => navigate({ to: '/products/create' })}
        >
          <Plus />
          Thêm sản phẩm mới
        </Button>
      </>
    )
  }

  return (
    <div className="">
      <TitleHeader
        title="Tổng quan"
        subtitle="Chào mừng bạn đến với Trung tâm thông tin dữ liệu của bạn!"
        action={groupActions()}
      />

      <div className="grid grid-cols-3 gap-6 mt-6">
        <div className="col-span-2">
          <StaticCard currency={currency} />

          <OrderChart currency={currency} />

          <PaymentChart currency={currency} />
        </div>

        <div className="col-span-1">
          <RecentOrders />
        </div>
      </div>
    </div>
  )
}
